// A user can pass in any combination of x/y min/max values through the panel configuration

import memoizeOne from 'memoize-one';

import {type DomainMaybe} from '../../vis/types';

// Domains of [200, null] or [null, 400] etc... and set upper or lower bounds for that axis
// This function needs to be stable so that it doesn't cause re-renders of the graph
export const getDomain = memoizeOne(
  (
    axisMin: number | undefined,
    axisMax: number | undefined
  ): DomainMaybe | undefined => {
    if (Number.isFinite(axisMin) || Number.isFinite(axisMax)) {
      return [axisMin ?? null, axisMax ?? null] as DomainMaybe;
    }

    return undefined;
  }
);
